import { render, staticRenderFns } from "./envShow.vue?vue&type=template&id=0f422623&scoped=true"
import script from "./envShow.vue?vue&type=script&lang=js"
export * from "./envShow.vue?vue&type=script&lang=js"
import style0 from "./envShow.vue?vue&type=style&index=0&id=0f422623&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f422623",
  null
  
)

export default component.exports